<template>
  <div class="page">
    <div class="img">
      <img src="~@/assets/img/new-img.jpg"/>
    </div>
    <div class="page-list">
      <div class="page-list-title">
        <el-tabs v-model="activeName" @tab-click="handleClick" class="page-tabs">
          <el-tab-pane label="企业要闻" name="1"></el-tab-pane>
          <el-tab-pane label="媒体报道" name="2"></el-tab-pane>
          <el-tab-pane label="视频展播" name="3"></el-tab-pane>
          <el-tab-pane label="刊物阅览" name="4"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="new-list-details" v-loading="state">
        <div v-for="(item,index) in data" @click="open(item)">
          <div style="width: 355px;height: 179px">
            <img :src="item.coverImage" style="width: 100%;height: 100%"/>
          </div>
          <div class="new-list-details-date">
            <div style="font-size: 20px">{{item.createTime}}</div>
          </div>
          <div class="new-list-details-content">
            <div>{{item.articleTitle}}</div>
            <div>
                 {{item.articleContent.length > 120 ?
                item.articleContent.replace(/nbsp;/g,'').replace(/&/g,"").replace(/<[^>]+>/g,"").substring(0,119) :
                item.articleContent.replace(/nbsp;/g,'').replace(/&/g,"").replace(/<[^>]+>/g,"") }}
             </div>
          </div>
        </div>

      </div>
      <div></div>
    </div>
    <div class="new-list-page">
      <el-pagination
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
        :current-page="pageIndex"
        :page-size="pageSize"
        :total="totalPage"
        layout="total,  prev, pager, next, jumper">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  export default {
    name: "new",
    data() {
      return {
        activeName: '1',
        pageIndex: 1,
        pageSize: 5,
        totalPage: 0,
        data: '',
        state: false,
        classType : ''
      }
    },
    mounted: function () {
      this.activeName = this.$route.query.id + ''
      this.getDataList()
    },
    watch: {
      '$route.query.id'(newValue, oldValue) {
        this.activeName = this.$route.query.id + ''
        this.getDataList()
      },
      deep: false
    },
    methods: {
      handleClick() {
        this.pageIndex = 1
        this.pageSize = 5
        this.getDataList()
      },
      open(obj) {
         this.$router.push({path: '/new-details', query: {id: (obj.id), title: this.title,classType : this.classType}})
      },
      getDataList() {
        this.state = true
        this.$http({
          url: this.$http.adornUrl('/website/getNews'),
          method: 'post',
          data: this.$http.adornData({
            "belongCity": 16,
            "infoType": this.activeName,
            "pageSize": this.pageSize,
            "page": this.pageIndex
          })
        }).then(({data}) => {
          this.state = false
          if (data && data.code === 0) {
            this.data = data.data.list
            this.totalPage = data.data.total
            this.classType =  data.data.classType
          } else {
            this.$message.error("服务器无响应!")
          }
        })
      },
      // 每页数
      sizeChangeHandle(val) {
        this.pageSize = val
        this.pageIndex = 1
        this.getDataList()
      },
      // 当前页
      currentChangeHandle(val) {
        this.pageIndex = val
        this.getDataList()
      },
    }
  }
</script>




// WEBPACK FOOTER //
// src/views/modules/new.vue